import { DisclosureType } from '@mortgage-pos/types'

export interface LeadTcpaFields {
  phoneTcpaProvider?: string | null
  phoneTcpaId?: string | null
  textTcpaProvider?: string | null
  textTcpaId?: string | null
}

const TCPA_CONSENT_TYPES = [
  DisclosureType.TcpaTransactionalConsent,
  DisclosureType.TcpaMarketingAndCustomerCareConsent,
]

export function getTcpaConsentTypes(lead: LeadTcpaFields): DisclosureType[] {
  const hasAllTcpaFields = [
    lead.phoneTcpaProvider,
    lead.phoneTcpaId,
    lead.textTcpaProvider,
    lead.textTcpaId,
  ].every((value) => Boolean(value?.trim()))

  return hasAllTcpaFields ? [...TCPA_CONSENT_TYPES] : []
}
